import { LucideIcon } from "lucide-react";

interface ContactItemProps {
  icon: LucideIcon;
  children: React.ReactNode;
}

const ContactItem = ({
  icon: Icon,
  children,
}: ContactItemProps) => {
  return (
    <div className="flex items-center space-x-3 md:justify-start justify-center font-semibold">
      <Icon className="h-4 w-4 text-black shrink-0  font-semibold" />

      <div className="text-lg text-black">
        {children}
      </div>
    </div>
  );
};

export default ContactItem;